import type { FC } from 'react'
import React from 'react'
import { UniversalImage } from '@components/common/UniversalImage'

const ClubOneImage: FC = () => {
  return <UniversalImage provider="next" alt={'ClubOne'} height="52" width="52" src="/images/clubOneImage.png" />
}

export default ClubOneImage
